
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Comment est-il administré?`}</em></p>
    <p>{`Il nécessite deux doses, à trois semaines d’écart. En janvier, un essai sur une
version à dose unique a commencé. Son nom? “Spoutnik Light”. La Russie a annoncé
en mai que l'efficacité était dans ce cas de 79,4%. Les détails de cette étude
n'ont toutefois pas été publiés. On ne sait pas non plus combien de temps dure
la protection. Le Spoutnik Light a été autorisé en Russie et dans plusieurs
autres pays.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;